<template>
  <div v-if="video">
    <div class="wide-screen play-icon" @click="playVideo">
      <img :src="video.thumb_url" class="img-view" data-index="{{ $key }}" alt="" />
    </div>
    <span ref="videoPlay" data-toggle="modal" :data-target="`#video-modal_${video.id}`"></span>

    <div class="modal fade" data-backdrop="static" :id="`video-modal_${video.id}`" aria-hidden="true">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog static modal-lg modal-dialog-centered vertical-align-center">
          <div class="modal-content">
            <div class="modal-body p-0" id="videoPlay">
              <div class="player-container">
                <video-js :id="`my_video_${video.id}`" class="vjs-default-skin vjs-big-play-centered" controls preload="auto" data-setup='{"fluid": true}'>
                  <source :src="video.embed_url" type="application/x-mpegURL">
                </video-js>
              </div>
            </div>
            <i class="fa fa-close" data-dismiss="modal" @click="resetModal"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['paramVideo', 'csrf'],
    data() {
      return {
        video: undefined,
        player: undefined
      }
    },
    mounted() {
      this.video = JSON.parse(this.paramVideo)

      let self = this
      this.$nextTick(function() {
        self.player = videojs(`my_video_${self.video.id}`);
      })
    },
    methods: {
      playVideo() {
        $('#showLoading').click();
        let self = this
        setTimeout(function() {
          self.$refs.videoPlay.click();
          $('#hideLoading').click();
          self.player.play()
        }, 500)
      },
      resetModal() {
        let self = this
        setTimeout(function() {
          self.player.pause()
        }, 200)
      }
    }
  }
</script>
